import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { theme } from '@contrast-security-inc/design-system-foundations'

const feedbackBtnStyle = css`
  margin-left: 8px;
`

const feedbackTextCss = css`
  white-space: nowrap;
`

export function FeedbackButton({ customUrl }: { readonly customUrl?: string }) {
  return (
    <div className={feedbackBtnStyle}>
      <a
        className={css`
          font-weight: 400;
          color: ${theme.color.white};
          text-transform: uppercase !important;
          letter-spacing: 0.01em;
          font-size: 12px;
          border-radius: 11.5px;
          height: 23px;
          padding: 0px 14px;
          align-items: center;
        `}
        target="_blank"
        href={
          customUrl
            ? customUrl
            : 'https://contrastsecurity.typeform.com/to/oAX2T5'
        }
      >
        <FormattedMessage id="action_giveUsFeedback">
          {(text) => <span className={feedbackTextCss}>{text}</span>}
        </FormattedMessage>
      </a>
    </div>
  )
}
